import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {PrintParameter, ReportTemplate, ServerFolder} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name reportServerDataService
 * @module use-cases.report-server
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing the report-server
 */
export default class ReportServerDataService {
    public static serviceName = 'reportServerDataService';

    private static readonly SERVER_FOLDER_ROUTE = 'report-server/server-folder';
    private static readonly TEMPLATE_ROUTE = 'report-server/templates';
    private static readonly PARAMETER_ROUTE = 'parameters';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getServerFolder(): Promise<ServerFolder> {
        return this.Restangular
            .one(ReportServerDataService.SERVER_FOLDER_ROUTE)
            .get<ServerFolder>();
    }

    @ngAsync()
    @unRestangularize()
    public async getTemplateParameters(report: ReportTemplate) : Promise<PrintParameter[]> {
        return this.Restangular
            .one(ReportServerDataService.TEMPLATE_ROUTE, report.id)
            .one(ReportServerDataService.PARAMETER_ROUTE)
            .getList<PrintParameter>();
    }
}
